var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"container_check"},[_vm._v(" "+_vm._s(_vm.value)+" "),_c('input',{attrs:{"type":"checkbox"}}),_c('span',{staticClass:"checkmark"})])}
var staticRenderFns = []

export { render, staticRenderFns }